var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// - Import react components
import { storageRef, db } from 'data/firestoreClient';
import store from 'store/configureStore';
import { SocialError } from 'core/domain/common';
import { ServiceProvide } from 'core/factories';
import * as globalActions from 'store/actions/globalActions';
import { injectable } from 'inversify';
/**
 * Firbase image gallery service
 *
 * @export
 * @class ImageGalleryService
 * @implements {IImageGalleryService}
 */
var ImageGalleryService = /** @class */ (function () {
    function ImageGalleryService() {
        var _this = this;
        this.getImageGallery = function (userId) {
            return new Promise(function (resolve, reject) {
                var imagesRef = db.doc("users/" + userId).collection("images");
                imagesRef.get().then(function (snapshot) {
                    var parsedData = [];
                    snapshot.forEach(function (result) {
                        parsedData.push(__assign({ id: result.id }, result.data()));
                    });
                    resolve(parsedData);
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        this.saveImage = function (userId, image) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var imageRef = db.doc("users/" + userId).collection("images").add(image);
                        imageRef.then(function (result) {
                            console.log('saveImage', result);
                            resolve(result.id);
                        })
                            .catch(function (error) {
                            reject(new SocialError(error.code, error.message));
                        });
                    })];
            });
        }); };
        this.deleteImage = function (userId, imageId) {
            return new Promise(function (resolve, reject) {
                var batch = db.batch();
                var imageRef = db.doc("users/" + userId + "/images/" + imageId);
                batch.delete(imageRef);
                batch.commit().then(function () {
                    resolve();
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        this.uploadImage = function (image, imageName, progressCallback) {
            return new Promise(function (resolve, reject) {
                _this.storageService.uploadFile(image, imageName, progressCallback)
                    .then(function (result) {
                    resolve(result);
                })
                    .catch(function (error) {
                    alert(error.message);
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        this.uploadImages = function (ImageArr) {
            return new Promise(function (resolve, reject) {
                var uploadedImages = [];
                ImageArr.forEach(function (img) {
                    var image = img.resizedImage;
                    var fileName = img.fileName;
                    _this.uploadImage(image, fileName, function (percentage) {
                        store.customDispatch(globalActions.progressChange(percentage, true));
                    })
                        .then(function (res) {
                        uploadedImages.push(res);
                        if (uploadedImages.length === ImageArr.length) {
                            // alert('equal')
                            resolve(uploadedImages);
                        }
                    }).catch(function (error) {
                        alert(error.message);
                    });
                });
            });
        };
        this.downloadImage = function (fileName) {
            return new Promise(function (resolve, reject) {
                // Create a reference to the file we want to download
                var starsRef = storageRef.child("images/" + fileName);
                // Get the download URL
                starsRef.getDownloadURL().then(function (url) {
                    resolve(url);
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        this.serviceProvider = new ServiceProvide();
        this.storageService = this.serviceProvider.createStorageService();
    }
    ImageGalleryService = __decorate([
        injectable()
    ], ImageGalleryService);
    return ImageGalleryService;
}());
export { ImageGalleryService };



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/services/imageGallery/ImageGalleryService.ts
// module id = 315
// module chunks = 50